import styles from "./Screen.module.css";
import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { useDispatch } from "react-redux";
import { setCurrentModule } from "../../store/reducers/progressionReducer";
import { logEvent } from "../../analytics";

export default function Module({ module, src, dispatch, analytics }) {
  const moduleToString = {
    eventRequestForm: "Event Request",
    patientData: "Patient Door Access",
    patientSelection: "Patient Selection",
    newService: "New service available",
    toriCalculator: "Toric Calculator",
    optimizedSelection: "Optimized Selection",
  };

  const svgRef = useRef();
  const gsapTween = useRef();
  const { contextSafe } = useGSAP();

  const hoverEffect = contextSafe((event) => {
    const element = event.currentTarget;
    const rect = element.getBoundingClientRect();

    const relativeX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    const relativeY = ((event.clientY - rect.top) / rect.height) * 2 - 1;

    const maxRotation = 20; // Ajustez cette valeur pour une rotation plus ou moins forte
    const rotationX = relativeY * maxRotation; // Rotation autour de l'axe X
    const rotationY = -relativeX * maxRotation; // Rotation autour de l'axe Y
    gsapTween.current?.kill();
    gsapTween.current = gsap.to(svgRef.current, {
      rotationX: rotationX / 2,
      rotationY: -rotationY,
      duration: 0.1,
      ease: "power2.out",
    });
  });

  const hoverOut = contextSafe(() => {
    gsapTween.current?.kill();
    gsapTween.current = gsap.to(svgRef.current, {
      rotationX: 0,
      rotationY: 0,
      duration: 1,
      ease: "power2.out",
    });
  });

  const handleClick = () => {
    if (analytics) {
      logEvent("Module", "click", analytics);
    }
    if (src) {
      window.open(src, "_blank"); // Ouvrir le lien dans un nouvel onglet
    } else {
      dispatch(setCurrentModule(module)); // Si pas de lien, dispatcher le module
    }
  };

  return (
    <div
      className={styles.module}
      onClick={handleClick} // Utiliser la nouvelle fonction handleClick

    >

      <div
        className={styles.container}
        ref={svgRef}
        onPointerMove={hoverEffect}
        onPointerLeave={hoverOut}
      >
        <svg
          preserveAspectRatio={"none"}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.outer}
        >
          <circle cx="50%" cy="50%" r="50%" stroke="#ADD2D4" />
        </svg>
        <svg
          preserveAspectRatio={"none"}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.inner}
        >
          <circle cx="50%" cy="50%" r="50%" stroke="#ADD2D4" />
        </svg>
        <img src={`/screen/${module}.svg`} alt="" />
      </div>
      <p>{moduleToString[module]}</p>
      {["optimizedSelection", "eventRequestForm"].includes(module) && <div className={styles.comingsoon}>Coming Soon</div>}

    </div >
  );
}
